import { render, staticRenderFns } from "./AdminGuard.vue?vue&type=template&id=ed791844"
import script from "./AdminGuard.vue?vue&type=script&lang=js"
export * from "./AdminGuard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports